import React from 'react'

import { SectionWrapper } from 'Components/Blocks'
import { Text } from 'Components/UI'

import HowStartupCraftFitsTogetherGlyph from 'Assets/Svg/howStartupCraftFitsTogether.svg'

import {
  CapabilityGrid,
  CapabilityGroup,
  DiagramWrapper,
  HeadingArea,
  Strong,
} from './styles'

// Mirrors the diagram exactly, group for group and label for label.
const CAPABILITY_GROUPS = [
  {
    id: 'operations',
    title: 'Operations & Data',
    items: [
      'Data Feeds',
      'Search',
      'Reporting',
      'Templates',
      'Custom Fields',
      'Spreadsheets',
    ],
  },
  {
    id: 'content',
    title: 'Content & Docs',
    items: ['Website Widgets', 'Docs', 'CMS', 'Files', 'PDF Generation'],
  },
  {
    id: 'workflow',
    title: 'Workflow & Automation',
    items: [
      'Gantt',
      'Automations',
      'Rostering',
      'Calendar',
      'Booking',
      'Scheduling',
      'Integrations',
      'Notifications',
    ],
  },
  {
    id: 'core',
    title: 'Core',
    items: ['CRM', 'Dashboards', 'Chat / Feed', 'AI'],
  },
  {
    id: 'governance',
    title: 'Users & Governance',
    items: [
      'Governance',
      'Data Security',
      'Users & Permissions',
      'Identity Management',
    ],
  },
  {
    id: 'ai',
    title: 'AI Surface',
    items: ['AI Agents', 'AI Writing', 'AI Chatbots', 'AI OCR', 'AI Voice'],
  },
  {
    id: 'support',
    title: 'Support & Communication',
    items: ['Inbox', 'Group Chats', 'Customer Support'],
  },
  {
    id: 'billing',
    title: 'Time & Billing',
    items: ['Timesheets', 'Billing'],
  },
]

function HowStartupCraftFitsTogetherSection() {
  return (
    <SectionWrapper py="120px">
      <HeadingArea>
        <Text as="h2" balanceWrap center semiLight title title40>
          How StartupCraft <Strong>fits together</Strong>
        </Text>
        <Text body body16 mt={7} semiLight>
          Composable. Production-ready. Built by senior engineers.
        </Text>
      </HeadingArea>

      <DiagramWrapper>{HowStartupCraftFitsTogetherGlyph()}</DiagramWrapper>

      <CapabilityGrid>
        {CAPABILITY_GROUPS.map(({ id, title, items }) => (
          <CapabilityGroup key={id}>
            <Text as="h3" body14 medium title>
              {title}
            </Text>

            <Text body body14 semiLight>
              {items.join(' · ')}
            </Text>
          </CapabilityGroup>
        ))}
      </CapabilityGrid>
    </SectionWrapper>
  )
}

export default HowStartupCraftFitsTogetherSection
